module.exports = __webpack_public_path__ + "static/img/son1_active.8c532d89.png";